import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Grid, Typography } from '@material-ui/core';
import DataGridAccordion from './ResultsDataGrid';
import { productJsonProps } from '../../Constants/Products';
import { get, isEmpty, isNil } from 'lodash';
import { getProductImgUrl, getProductPdpUrl } from '../../Utils/ProductUtils';
import ManageProductButton from '../ManageProduct/ManageProductButton';
import ProductLowesBtn from '../Product/ProductLowesBtn';
import { Tooltip } from '@material-ui/core';
import ProductBuyable from '../Product/ProductBuyable';
import ProductGridFilters from './ProductGridFilters';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProductGridData } from '../../redux/actions/resultsActions';

const useStyles = makeStyles((theme) => ({
	productName: {
		'& span:first-child': {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			width: '275px',
			display: 'block',
		},
	},
	sourceAvatar: {
		height: '3em',
	},
}));

const ProductName = ({ product }) => {
	const classes = useStyles();
	const prodImgUrl = getProductImgUrl(product);
	const name = get(product, productJsonProps.name);
	return (
		<Grid container>
			<Grid item xs={3}>
				<Avatar src={prodImgUrl} variant="square" className={classes.sourceAvatar}>
					Product
				</Avatar>
			</Grid>
			<Grid item xs={9}>
				<Tooltip title="view product details page" placement="top" arrow={true}>
					<div className={classes.productName}>
						<ManageProductButton id={product.id} label={name}></ManageProductButton>
					</div>
				</Tooltip>
			</Grid>
		</Grid>
	);
};

const columns = [
	{
		field: 'name',
		headerName: 'Name',
		width: 400,
		renderCell: (params) => {
			const row = params.row;
			return <ProductName product={row} />;
		},
		editable: true,
	},
	{
		field: 'id',
		headerName: 'Product ID',
		width: 175,
		renderCell: (params) => {
			const row = params.row;
			const productId = get(row, productJsonProps.productId);
			const pdUrl = getProductPdpUrl(row);
			return (
				<>
					<Typography variant="body1">{productId}</Typography>
					<ProductLowesBtn pdUrl={pdUrl} text="" />
				</>
			);
		},
	},
	{
		field: 'ItemNumber',
		headerName: 'Item Number',
		type: 'text',
		width: 175,
		renderCell: (params) => {
			const row = params.row;
			const itemNumber = get(row, productJsonProps.itemNumber);
			return <Typography variant="body1">{itemNumber}</Typography>;
		},
		editable: true,
	},
	{
		field: 'VendorNumber',
		headerName: 'Vendor Number',
		type: 'text',
		width: 175,
		renderCell: (params) => {
			const row = params.row;
			const vendorNumber = get(row, productJsonProps.vendorNumber);
			return <Typography variant="body1">{vendorNumber}</Typography>;
		},
		editable: true,
	},
	{
		field: 'ModelId',
		headerName: 'Model Id',
		type: 'text',
		width: 175,
		renderCell: (params) => {
			const row = params.row;
			const modelNumber = get(row, productJsonProps.modelId);
			return <Typography variant="body1">{modelNumber}</Typography>;
		},
		editable: true,
	},
	{
		field: 'Buyable',
		headerName: 'Buyable',
		type: 'text',
		width: 125,
		renderCell: (params) => {
			const row = params.row;
			const isBuyable = get(row, productJsonProps.buyable);
			return <ProductBuyable isBuyable={isBuyable} />;
		},
		editable: true,
	},
	{
		field: 'category',
		headerName: 'Category',
		type: 'text',
		width: 150,
		renderCell: (params) => {
			const row = params.row;
			const cat = get(row, productJsonProps.category);
			const catVal = cat[Object.keys(cat)[0]];
			return <Typography variant="body1">{catVal}</Typography>;
		},
		editable: true,
	},
];
export default function ProductDataGrid({ searchTerm }) {
	const productsData = useSelector((state) => state.results.productsData);
	const dispatch = useDispatch();
	const products = productsData.data;
	const totalHits = productsData.count;
	const [filteredProducts, setFilteredProducts] = useState(products);
	const [rowsState, setRowsState] = React.useState({
		page: 0,
		pageSize: 25,
		rows: filteredProducts,
		loading: false,
	});
	const productFilters = useSelector((state) => state.results.productFilters);
	const { isBuyable } = productFilters;

	useEffect(() => {
		if (!isEmpty(searchTerm) && !isNil(searchTerm)) {
			const { page, pageSize } = rowsState;
			let active = true;
			(async () => {
				setRowsState((prev) => ({ ...prev, loading: true }));
				await dispatch(fetchProductGridData(searchTerm, (page + 1) * pageSize, page * pageSize, isBuyable));
				if (!active) {
					return;
				}
			})();
		}
		//eslint-disable-next-line
	}, [searchTerm, dispatch, rowsState.pageSize, rowsState.page, isBuyable]);

	useEffect(() => {
		setRowsState((prev) => ({ ...prev, loading: false, rows: filteredProducts }));
	}, [filteredProducts]);

	return (
		<DataGridAccordion
			rows={filteredProducts}
			{...rowsState}
			columns={columns}
			label={'Products'}
			totalHits={totalHits}
			filterComponent={
				<ProductGridFilters products={products} setFilteredProducts={setFilteredProducts} query={searchTerm} />
			}
			setRowState={setRowsState}
		/>
	);
}
